module.exports = __webpack_public_path__ + "img/wallet1.dfa13613.png";